<template>
  <div class="option-switch" :style="{ maxWidth: 116 * options.length + 'px' }">
    <div
      class="background"
      :style="{ left: backgroundOffset }"
      :class="selectedOption.class"
    />
    <div class="options">
      <div
        v-for="option in options"
        :key="option.value"
        :class="option == selectedOption ? 'selected' : ''"
        class="option"
        @click="selectOption(option)"
      >
        <span style="font-size:14px;">{{ option.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OptionSwitch",
  props: {
    options: {
      type: Array,
      default: () => []
    },
    value: {
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      offsetWidth: 0,
      borderWidth: 0
    };
  },
  mounted() {
    setTimeout(() => {
      this.offsetWidth = document.querySelector(":scope .option").offsetWidth;
      const bg = document.querySelector(":scope .background");
      const borderLeft = +getComputedStyle(bg).borderLeftWidth.slice(0, -2);
      const borderRight = +getComputedStyle(bg).borderRightWidth.slice(0, -2);
      this.borderWidth = (borderLeft + borderRight) / 2;
    }, 250);
  },
  methods: {
    selectOption(option) {
      if (!option.disabled) {
        this.$emit("input", option.value);
      }
    }
  },
  computed: {
    selectedOption() {
      return this.options.find(u => u.value == this.value);
    },
    backgroundOffset() {
      const index = this.options.indexOf(this.selectedOption);
      return index * this.offsetWidth - index * this.borderWidth + "px";
    }
  }
};
</script>

<style scoped>
.option-switch {
  position: relative;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 5px 0px #ccc;
  height: 33px;
  width: 100%;
}

.background {
  position: absolute;
  top: 0;
  left: 0;
  width: calc(123px - 6px);
  height: calc(100% - 6px);
  border-radius: 20px;
  border: 3px solid white;
  transition: left 123ms ease-out;
  box-sizing: content-box;
}

.options {
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  position: relative;
  z-index: 1;
}

.option {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #b1b1b1;
  cursor: pointer;
  transition: color 123ms ease-out;
  width: 100%;
}

.option.selected {
  color: white;
}
</style>
